// HOOKS
import { createContext, useContext, useEffect } from "react";
import useUpdateShipment from "../../hooks/shipments/useUpdate.shipment";
import useGetManyShipments from "../../hooks/shipments/useGetMany.shipment";
// CONTEXT
import { SelectedTicketsContext } from "../tickets/selectedTickets.context";

export const ShipmentsContext = createContext({
  shipments: [],
  setShipments: () => {},
  getShipments: () => {},
  metaData: {},
  setMetaData: () => {},
  shipmentInput: {},
  setShipmentInput: () => {},
  query: {},
  setQuery: () => {},
  handleLimitChange: () => {},
  handlePageChange: () => {},
  handleSearch: () => {},
  handleSort: () => {},
  isLoading: false,
  error: null,
  handleChange: () => {},
  handleMultiSelectChange: () => {},
});

export const ShipmentsProvider = ({ children }) => {
  const {
    shipments,
    setShipments,
    getShipments,
    metaData,
    setMetaData,
    shipmentInput,
    setShipmentInput,
    setQuery,
    query,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
    loading: isLoading,
    error,
  } = useGetManyShipments();
  const {
    updateShipment,
    data: shipmentUpdate,
    error: updateError,
  } = useUpdateShipment();
  const { selectedTickets, setSelectedTickets } = useContext(
    SelectedTicketsContext
  );

  const handleMultiSelectChange = async (event) => {
    try {
      event.preventDefault();
      const { name, id, reset, parent_id } = event.target.dataset;
      const selectedTicket = selectedTickets.find(
        (ticket) => ticket.id === +id
      );

      const shipment = shipments.find((shipment) => shipment._id === parent_id);
      console.log({ selectedTicket });
      console.log({ shipment, id });

      const options = shipment?.[name];
      if (!options) return console.error("No options found");
      const getChange = () => {
        if (reset)
          return {
            _id: shipment._id,
            customer_id: shipment?.customer_id,
            [name]: [],
          };
        if (options?.find((value) => value.id === +id)) {
          return {
            _id: shipment._id,
            customer_id: shipment?.customer_id,
            [name]: options.filter((value) => value.id !== +id),
          };
        }
        return {
          _id: shipment._id,
          customer_id: shipment?.customer_id,
          [name]: [
            ...options,
            {
              id: selectedTicket.id,
              number: selectedTicket.number,
              customer_id: selectedTicket?.customer_id,
              customer_business_then_name:
                selectedTicket?.customer_business_then_name,
              contact_id: selectedTicket?.invoice_contacts?.[0]?.id,
              _id: selectedTicket._id,
            },
          ],
        };
      };
      const change = getChange();
      setShipments((prev) => {
        return prev.map((shipment) => {
          if (shipment?._id === parent_id) {
            return { ...shipment, [name]: change[name] };
          }
          return shipment;
        });
      });
      await updateShipment(change);
    } catch (err) {
      console.error(`Error handling multi select change: ${err.message}`);
    }
  };

  useEffect(() => {
    const updatedShipment = shipmentUpdate?.updateShipment;
    if (shipmentUpdate) {
      setShipments((prev) => {
        return prev.map((shipment) => {
          if (shipment?._id === updatedShipment?._id) {
            return updatedShipment;
          }
          return shipment;
        });
      });
    }
  }, [shipmentUpdate]);

  useEffect(() => {
    if (updateError) getShipments();
  }, [updateError]);

  return (
    <ShipmentsContext.Provider
      value={{
        shipments,
        setShipments,
        getShipments,
        metaData,
        setMetaData,
        shipmentInput,
        setShipmentInput,
        setQuery,
        query,
        handleLimitChange,
        handlePageChange,
        handleSearch,
        handleSort,
        isLoading,
        error,
        handleMultiSelectChange,
      }}
    >
      {children}
    </ShipmentsContext.Provider>
  );
};
